import React from "react";
import MuiBox from "@mui/material/Box";
import Box from "components/common/Box";
import NavPill from "components/allInOneDashboard/nav/NavPill";
import { NAV_ITEM_GAP } from "components/allInOneDashboard/constants/navTheme";

const NavLinks = ({ items, isActive, onItemClick, isItemDisabled }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      minWidth: 0,
      overflowX: "auto",
      overflowY: "hidden",
      "&::-webkit-scrollbar": { display: "none" },
      msOverflowStyle: "none",
      scrollbarWidth: "none",
    }}
  >
    <MuiBox
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: NAV_ITEM_GAP,
        flexWrap: "nowrap",
        py: 0.5,
        position: "relative",
        width: "auto",
      }}
    >
      {items.map((item) => (
        <NavPill
          key={item.id}
          label={item.label}
          active={isActive(item)}
          disabled={isItemDisabled?.(item)}
          onClick={() => onItemClick(item)}
        />
      ))}
    </MuiBox>
  </Box>
);

export default NavLinks;
